define([
	"dojo/_base/declare",
	"dojo/_base/event",
	"dojo/keys",
	"csi/html"
], function(declare, event, keys, html) {

	return declare(null, {
        /** @property {boolean} bHandleEnter - indicates if should allow line breaks in value */
		bHandleEnter: true,

        postCreate: function() {
			this.inherited(arguments);

			// There is a little difference between Chrome and Safari when dealing with the onkeyup event, for example, if we input "a", hit "Option + Enter", we would get the value like 
			// the following
			// Chrome: a  Safari: a"\n"
			// So, use onkeydown instead
			this.connect(this.focusNode, "onkeydown", "_onKeyDown");
		},

		_insertLineBreak: function() {
			// summary: add soft line break on demand
			var value = this.get("value");
			var pos = html.getCursorPosition(this);
			this.set("value", value.substring(0, pos) + "\n" + value.substring(pos, value.length));
			html.setCursorPosition(this, pos + 1, pos + 1);
		},

		_onKeyDown: function(/*Event*/e) {
			// summary: special support for newlines on Chrome
			if (this.bHandleEnter && (e.altKey || e.ctrlKey || e.metaKey) && (e.keyCode == keys.ENTER)) {
				this._insertLineBreak();
				event.stop(e);
			}
		}
	});
});